import React from 'react'
import ReactDOM from 'react-dom'
class SkillList extends React.Component {
  render() { 
    return (
      <span className=""> {this.props.name}. </span>
    );
  }
};
export default SkillList